module.exports = __webpack_public_path__ + "static/media/gry-edukacyjne-online-dla-dzieci.df8379e9.png";